import env from 'env';

const getBaseUrl = (url: string) => {
  const match = url.match(/^(https?:\/\/[^/]+)/);

  return match ? match[1] : url;
};

type IParams = {
  h?: number;
  w?: number;
  fallback?: '404' | 'lettermark' | 'icon' | 'symbol';
};

export const getCompanyLogoUrl = async (
  website: string,
  params = {
    fallback: '404',
  } satisfies IParams,
) => {
  const baseUrl = getBaseUrl(website);
  const normalizedWebsite = baseUrl
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .trim();

  if (!normalizedWebsite) return;

  const queryParams = Object.entries(params)
    .map(([key, value]) => `${key}/${value}`)
    .join('/');

  return `https://cdn.brandfetch.io/${normalizedWebsite}/${queryParams}?c=${env.BRANDFETCH_CLIENT_ID}`;
};
